import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, Checkbox, Grid, Space, Table, Tooltip, Typography } from 'antd';
import { CloseCircleOutlined, PlusOutlined, SyncOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import '../../App.css';
import CancelRequestDialog from './cancelRequestDialog';
import RenewCertificateDialog from './renewCertificateDialog';
import { searchCertificatesRenewalReqReact } from '../../services/certificateService';
import CertificateExcelDownload from './certificateExcelDownload';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
const CertificateDataTable = ({ data, tableDataItem, loading, pagination, onChange, searchCertRequest, reLoadData }) => {
    var _a, _b, _c;
    const [tableData, setTableData] = useState([]);
    const [isCancelReqDialogVisible, setIsCancelReqDialogVisible] = useState(false);
    const [isReNewModalVisible, setIsReNewModalVisible] = useState(false);
    const [record, setRecord] = useState(null);
    const [certDataList, setCertDataList] = useState(null);
    const applicationData = useSelector((state) => state.applicationData);
    const [checkedValues, setCheckedValues] = useState([]);
    const handleCancelReqDialog = (record) => {
        setRecord(record);
        setIsCancelReqDialogVisible(true);
    };
    const [visibleColumns, setVisibleColumns] = useState({
        productname: false,
        servicename: false,
        factoryname: false,
        lab: false,
        certificateholder: false,
        bvlocation: false,
        bvlocationname: false,
    });
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        setVisibleColumns({
            productname: (_a = checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.includes("Product")) !== null && _a !== void 0 ? _a : false,
            servicename: (_b = checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.includes("Service")) !== null && _b !== void 0 ? _b : false,
            factoryname: (_c = checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.includes("Factory/Importer/OEM")) !== null && _c !== void 0 ? _c : false,
            lab: (_d = checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.includes("Lab")) !== null && _d !== void 0 ? _d : false,
            certificateholder: (_e = checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.includes("Certificate Holder")) !== null && _e !== void 0 ? _e : false,
            bvlocation: (_f = checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.includes("BV Location")) !== null && _f !== void 0 ? _f : false,
            bvlocationname: (_g = checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.includes("BV Location")) !== null && _g !== void 0 ? _g : false,
        });
    }, [checkedValues]);
    const handleReNewOpenModal = (record) => {
        var _a, _b;
        let comapnyId = null;
        if (record && data) {
            comapnyId = (_b = (_a = data.find(item => item.intUniqueCertificateId === record.intUniqueCertificateId)) === null || _a === void 0 ? void 0 : _a.objLuCompany) === null || _b === void 0 ? void 0 : _b.intId;
        }
        setRecord(record);
        setCertDataList([]);
        const searchCertReqObj = {
            intClientId: comapnyId,
            boolCancelledCertificate: true,
            boolExpiredCertificate: true,
            boolLimitedValidity: true,
            boolGenericCall: true,
            boolRenwalRequired: true,
            intRenewalUnDecided: null,
            lstLuCertificateScope: [
                {
                    intId: 1,
                    strLongDesc: 'Valid',
                    intStatusCount: 0
                },
                {
                    intId: 2,
                    strLongDesc: 'Expired',
                    intStatusCount: 0
                }
            ],
            lstLuRenewalStatus: [
                {
                    intId: 6010,
                    strLongDesc: 'Renewal Undecided',
                    intStatusCount: 0
                }
            ],
            intCertStatus: 1806,
            strSeriesModel: record.strSeriesModel
        };
        searchCertificatesRenewalReqReact(searchCertReqObj).then((res) => {
            setCertDataList(res);
            setIsReNewModalVisible(true);
        });
    };
    useEffect(() => {
        if (data) {
            const newData = data.map((item, index) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                let renewalRequiredValue = 3;
                if ((item === null || item === void 0 ? void 0 : item.boolShowRenewalCertSelectOption) == true &&
                    ((_a = item === null || item === void 0 ? void 0 : item.objLuCertVerification) === null || _a === void 0 ? void 0 : _a.intId) == 1806 &&
                    ((_b = item === null || item === void 0 ? void 0 : item.objCertStatus) === null || _b === void 0 ? void 0 : _b.intId) != 4 &&
                    (item === null || item === void 0 ? void 0 : item.intIACert) != 2) {
                    renewalRequiredValue = 1;
                }
                else if (((_c = item === null || item === void 0 ? void 0 : item.objCertRenewalStatus) === null || _c === void 0 ? void 0 : _c.intId) == 6030 && item.intIACert != 2) {
                    renewalRequiredValue = 2;
                }
                const CertEncodedId = btoa(((_d = item === null || item === void 0 ? void 0 : item.intUniqueCertificateId) === null || _d === void 0 ? void 0 : _d.toString()) || '');
                return {
                    key: index,
                    entityname: ((_e = item.objLuCompany) === null || _e === void 0 ? void 0 : _e.strLongDesc) || '',
                    productmodel: item.strSeriesModel || '',
                    brand: ((_f = item.objBrandName) === null || _f === void 0 ? void 0 : _f.strLongDesc) || '',
                    country: ((_g = item.objLuCountry) === null || _g === void 0 ? void 0 : _g.strLongDesc) || '',
                    certificatename: (item === null || item === void 0 ? void 0 : item.strServiceName) || '',
                    certificateid: item.strCertId || '',
                    issuedate: item.strdtCertDate || '',
                    expirationdate: item.strdtCertExpDate || '',
                    certificatestatus: ((_h = item.objCertStatus) === null || _h === void 0 ? void 0 : _h.strLongDesc) || '',
                    decisiondate: item.strdtRenewalDate || '',
                    renewalstatus: ((_j = item === null || item === void 0 ? void 0 : item.objCertRenewalStatus) === null || _j === void 0 ? void 0 : _j.strLongDesc) || '',
                    renewalRequired: typeof renewalRequiredValue === 'number' ? renewalRequiredValue : undefined,
                    strSeriesModel: item.strSeriesModel || '',
                    intUniqueCertificateId: Number(item === null || item === void 0 ? void 0 : item.intUniqueCertificateId) || undefined,
                    intIACert: item === null || item === void 0 ? void 0 : item.intIACert,
                    uniqueCertificateId: CertEncodedId || '',
                    productname: ((_l = (_k = item === null || item === void 0 ? void 0 : item.objTblService) === null || _k === void 0 ? void 0 : _k.objLuProductMainType) === null || _l === void 0 ? void 0 : _l.strLongDesc) || '',
                    servicename: ((_o = (_m = item === null || item === void 0 ? void 0 : item.objTblService) === null || _m === void 0 ? void 0 : _m.objLuServiceCode) === null || _o === void 0 ? void 0 : _o.strLongDesc) || '',
                    factoryname: ((_p = item === null || item === void 0 ? void 0 : item.objEEMaster) === null || _p === void 0 ? void 0 : _p.strFactoryName) || '',
                    lab: (item === null || item === void 0 ? void 0 : item.strLab) || '',
                    certificateholder: (item === null || item === void 0 ? void 0 : item.strCertificateHolder) || '',
                    bvlocation: ((_q = item === null || item === void 0 ? void 0 : item.objBusinessunit) === null || _q === void 0 ? void 0 : _q.strBusinessUnitName) || '',
                };
            });
            setTableData(newData);
        }
    }, [data]);
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const columns = [
        tableDataItem || {
            title: 'Action',
            key: 'operation',
            fixed: screens.xs ? false : 'left',
            width: 70,
            render: (text, record) => (_jsx("div", { className: "cancel-icon-container", children: record.renewalRequired === 2 ? (_jsx(Tooltip, { title: "Cancel Request Quotation", placement: "right", children: _jsx(CloseCircleOutlined, { style: { color: 'red' }, onClick: () => handleCancelReqDialog(record), className: "cancel-icon" }) })) : record.renewalRequired === 1 ? (_jsx(Tooltip, { title: "Select For More Options", placement: "right", children: _jsx(SyncOutlined, { onClick: () => handleReNewOpenModal(record), className: "select-icon" }) })) : ('') }))
        },
        {
            title: 'Entity Name',
            width: 120,
            dataIndex: 'entityname',
            key: 'entityname'
        },
        {
            title: 'Product Model',
            width: 140,
            dataIndex: 'productmodel',
            key: 'productmodel'
        },
        {
            title: 'Brand/OEM',
            dataIndex: 'brand',
            key: 'brand',
            width: 120
        },
        {
            title: 'Country',
            dataIndex: 'country',
            key: 'country',
            width: 120
        },
        {
            title: 'Certificate Name',
            dataIndex: 'certificatename',
            key: 'certificatename',
            width: 140
        },
        {
            title: 'Certificate ID',
            dataIndex: 'certificateid',
            key: 'certificateid',
            width: 120,
            render: (text, record) => (_jsx(Link, { to: `/certificates/details/${record === null || record === void 0 ? void 0 : record.uniqueCertificateId}`, target: "_blank", children: record === null || record === void 0 ? void 0 : record.certificateid }))
        },
        {
            title: 'Issue Date',
            dataIndex: 'issuedate',
            key: 'issuedate',
            width: 120
        },
        {
            title: 'Expiration Date',
            dataIndex: 'expirationdate',
            key: 'expirationdate',
            width: 140
        },
        {
            title: 'Recommended Decision Date',
            dataIndex: 'decisiondate',
            key: 'decisiondate',
            width: 140
        },
        visibleColumns.productname && {
            title: 'Product Name',
            dataIndex: 'productname',
            key: 'productname',
            width: 140
        },
        visibleColumns.servicename && {
            title: 'Service Type',
            dataIndex: 'servicename',
            key: 'servicename',
            width: 140
        },
        visibleColumns.factoryname && {
            title: 'Factory/Importer/OEM',
            dataIndex: 'factoryname',
            key: 'factoryname',
            width: 140
        },
        visibleColumns.lab && {
            title: 'Lab',
            dataIndex: 'lab',
            key: 'lab',
            width: 140
        },
        visibleColumns.certificateholder && {
            title: 'Certificate Holder',
            dataIndex: 'certificateholder',
            key: 'certificateholder',
            width: 140
        },
        visibleColumns.bvlocation && {
            title: 'BV Location',
            dataIndex: 'bvlocation',
            key: 'bvlocation',
            width: 140
        },
        {
            title: 'Certificate Status',
            dataIndex: 'certificatestatus',
            key: 'certificatestatus',
            width: 100,
            fixed: screens.xs ? false : "right",
        },
        {
            title: 'Renewal Status',
            dataIndex: 'renewalstatus',
            key: 'renewalstatus',
            width: 100,
            fixed: screens.xs ? false : "right",
        },
    ].filter(Boolean);
    const options = [
        "Product",
        "Service",
        "Factory/Importer/OEM",
        "Lab",
        "Certificate Holder",
        "BV Location",
    ];
    const handleCheckboxChange = (value, checked) => {
        setCheckedValues((prev) => checked ? [...prev, value] : prev.filter((item) => item !== value));
    };
    return (_jsxs(Card, { size: tableDataItem ? 'small' : 'default', style: { borderRadius: '0px' }, title: !tableDataItem ? (_jsxs(Typography.Text, { children: ["Certificate Search Result (Total Records: ", pagination.total, " )"] })) : (`Certificate Details`), extra: _jsxs(Space, { children: [_jsx(CertificateExcelDownload, { data: data, searchCertRequest: searchCertRequest, filename: 'Certificates' }), _jsx(Tooltip, { title: "Please Upgrade Membership.", zIndex: ((_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _a === void 0 ? void 0 : _a.boolCertificateUploadCertificateFeature) ? -1 : 0, children: !((_b = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _b === void 0 ? void 0 : _b.boolCertificateUploadCertificateFeature) ?
                        _jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), disabled: true, children: "Certificates" })
                        : _jsx(Link, { to: `/certificates/create-new-certificate`, target: "_blank", rel: "noopener noreferrer", children: _jsx(Button
                            // onClick={handleAddNewCertificate}
                            , { 
                                // onClick={handleAddNewCertificate}
                                type: "primary", icon: _jsx(PlusOutlined, {}), disabled: !((_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _c === void 0 ? void 0 : _c.boolCertificateUploadCertificateFeature), children: "Certificates" }) }) })] }), children: [_jsx(CancelRequestDialog, { handleOk: () => setIsCancelReqDialogVisible(false), modelContent: record, handleCancel: () => setIsCancelReqDialogVisible(false), visible: isCancelReqDialogVisible, reLoadData: reLoadData }), _jsx(RenewCertificateDialog, { handleOk: () => setIsReNewModalVisible(false), data: data, modelContent: record, modelDataTableData: certDataList, handleCancel: () => setIsReNewModalVisible(false), visible: isReNewModalVisible, reLoadData: reLoadData }), _jsx(Table, { columns: columns === null || columns === void 0 ? void 0 : columns.filter((_) => _ !== undefined), dataSource: tableDataItem ? [tableDataItem] : tableData, scroll: {
                    x: 1400
                }, pagination: pagination, onChange: onChange, size: 'small', loading: loading }), options.map((option) => (_jsx(Checkbox, { style: { gap: "2px" }, checked: checkedValues.includes(option), onChange: (e) => handleCheckboxChange(option, e.target.checked), children: option }, option)))] }));
};
export default CertificateDataTable;
